import discount from 'components/Icons/Discount';
import { BiHome, BiStore } from 'react-icons/bi';

export const navBarRoutes = [
  { path: '/', icon: discount, name: 'discount deals' },
  { path: '/', icon: BiHome, name: 'home' },
  { path: '/', icon: BiStore, name: 'store' },
];
